var EStatus;
(function (EStatus) {
    EStatus["DEFAULT"] = "default";
    EStatus["SUCCESS"] = "success";
    EStatus["ERROR"] = "error";
})(EStatus || (EStatus = {}));
var TEnabledTypes;
(function (TEnabledTypes) {
    TEnabledTypes["EMAIL"] = "email";
    TEnabledTypes["NUMBER"] = "number";
    TEnabledTypes["PASSWORD"] = "password";
    TEnabledTypes["TEL"] = "tel";
    TEnabledTypes["TEXT"] = "text";
    TEnabledTypes["URL"] = "url";
})(TEnabledTypes || (TEnabledTypes = {}));
var FontScale;
(function (FontScale) {
    FontScale[FontScale["FONT_MAX"] = 1] = "FONT_MAX";
    FontScale[FontScale["FONT_MIN"] = 0.575] = "FONT_MIN";
    FontScale[FontScale["FONT_PROGRESS"] = 0.025] = "FONT_PROGRESS";
})(FontScale || (FontScale = {}));
var FieldFilled;
(function (FieldFilled) {
    FieldFilled[FieldFilled["MIN"] = 85] = "MIN";
    FieldFilled[FieldFilled["MAX"] = 90] = "MAX";
    FieldFilled[FieldFilled["SCROLL_HEIGHT"] = 60] = "SCROLL_HEIGHT";
    FieldFilled[FieldFilled["LINE_HEIGHT"] = 56] = "LINE_HEIGHT";
})(FieldFilled || (FieldFilled = {}));

export { EStatus, FieldFilled, FontScale, TEnabledTypes };
//# sourceMappingURL=types.js.map
